import templatelist from '../../../playturbo/src/lang/zh/templateList'
import versionlist from '../../../playturbo/src/lang/zh/versionList'
import login from '../../../playturbo/src/lang/zh/login'
import forget from '../../../playturbo/src/lang/zh/forget'
import profile from '../../../playturbo/src/lang/zh/profile'
import navbar from '../../../playturbo/src/lang/zh/navbar'
import ptCommon from '../../../playturbo/src/lang/zh/common'
import custom from '../../../playturbo/src/lang/zh/custom'
import creative from '../../../playturbo/src/lang/zh/creative'
import websocket from '../../../playturbo/src/lang/zh/websocket'
import uploader from './zh/uploader'
import cropperDialog from './zh/cropperDialog'
import frameSelectDialog from './zh/frameSelectDialog'
import gamePlay from '../../../playturbo/src/lang/zh/gamePlay'
import report from '../../../playturbo/src/lang/zh/report'
import common from './zh/common.js'
import commonTemplate from '../../../playturbo/src/lang/zh/commonTemplate.js'
import deliveryList from '../../../playturbo/src/lang/zh/deliveryList'
import dispatcher from '../../../playturbo/src/lang/zh/dispatcher'
import privacy from '../../../playturbo/src/lang/zh/privacy'
import commonNavbar from './zh/downloadBasic'
import basic from '@com/lang/zh/basic'
import workbench from '@com/lang/zh/workbench'
import userJourney from '@com/lang/zh/userJourney'
import resourceManager from '@com/lang/zh/resourceManager'
import record from '@pt/lang/zh/record'
import account from '@pt/lang/zh/account'
import guideTour from '@pt/lang/zh/guideTour'
import home from '@pt/lang/zh/home'
import leftMenu from '@pt/lang/zh/leftMenu'
import navbarTool from '@pt/lang/zh/navbarTool'
import whole from '@pt/lang/zh/whole'
import assetLibrary from '@pt/lang/zh/assetLibrary'
import exportHistory from '@pt/lang/zh/exportHistory'
import picturesVideos from '@pt/lang/zh/picturesVideos'
import playableAds from '@pt/lang/zh/playableAds'
import playableProject from '@pt/lang/zh/playableProject'
import promoteManagement from '@pt/lang/zh/promoteManagement'
import recordManagement from '@pt/lang/zh/recordManagement'
import recordProject from '@pt/lang/zh/recordProject'
import templateLibrary from '@pt/lang/zh/templateLibrary'
import pushDialog from '@pt/lang/zh/pushDialog'
import authAccount from '@pt/lang/zh/authAccount'
import videoProject from '@pt/lang/zh/videoProject'
import dashboard from '@pt/lang/zh/dashboard'
import ce from '@pt/lang/zh/ce'
import locale from '@ve-pro/ve/lang/locales/zh-cn.json'
import taskCenter from '@pt/lang/zh/taskCenter'
import billing from '@pt/lang/zh/billing'
import activities from '@pt/lang/zh/activities'
import rev from '@pt/lang/zh/rev'
import preView from '@ps/lang/zh/preview'
import trial from '@pt/lang/zh/trial'
import register from '@pt/lang/zh/register'
import order from '@pt/lang/zh/order'
import permission from '@pt/lang/zh/permission'
import payment from '@pt/lang/zh/payment'
import aiBanner from '@pt/lang/zh/aiBanner'
import voiceLab from '@pt/lang/zh/voiceLab'

import aiLocale from '@ai/lang/locales/zh-cn.json'

// 引入视频编辑器国家化内容，由于视频编辑器key体系之后一级，配置在playTurbo字段会导致无法生成国际化配置，手动拼接playTurbo key名称引入到i18n根目录
const vePro = {}
Object.keys(locale).forEach((key) => {
  vePro['playTurbo.' + key] = locale[key]
})

export default {
  basic,
  workbench,
  userJourney,
  resourceManager,
  commonNavbar,
  form: {
    platform: '平台',
    type: '类别',
    starttime: '开始时间',
    timeseparator: '至',
    endtime: '结束时间',
    keyword: '关键词',
    search: '搜索',
    pastWeek: '最近一周',
    pastMonth: '最近一个月',
    past3Month: '最近三个月',
    pastHalfYear: '最近半年',
    pastYear: '最近一年',
  },
  common: common,
  uploader,
  cropperDialog,
  frameSelectDialog,
  playTurbo: {
    navbar,
    login,
    forget,
    profile,
    trial,
    register,
    templatelist,
    pushDialog,
    authAccount,
    versionlist,
    commonTemplate,
    common: ptCommon,
    custom,
    creative,
    gamePlay,
    report,
    deliveryList,
    websocket,
    dispatcher,
    privacy,
    record,
    account,
    guideTour,
    home,
    leftMenu,
    navbarTool,
    whole,
    ce,
    assetLibrary,
    exportHistory,
    picturesVideos,
    playableAds,
    playableProject,
    promoteManagement,
    recordManagement,
    recordProject,
    templateLibrary,
    videoProject,
    dashboard,
    taskCenter,
    billing,
    activities,
    rev,
    order,
    permission,
    payment,
    voiceLab,
    aiBanner,
  },
  preview: {
    preView,
  },
  ...vePro,
  ai: aiLocale,
}
